import { Injectable } from '@angular/core';
import { Http, Headers, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { BrokerService, StorageService, URLFactory } from '@c4/core';

import { AuthenticationStrategy } from './authentication-strategy';
import { AuthenticationState } from '../services/authentication-state';

@Injectable()
export class Local implements AuthenticationStrategy {

  authentication: Observable<AuthenticationState>;

  constructor(
    // NOTE http service is used here directly because using broker would create a circular reference
    private http: Http,
    private url: URLFactory,
    private storage: StorageService
  ) { }

  authenticate(profile: string, password: string): Promise<any> {
    console.log('local.ts: authenticate()');
    return new Promise((resolve, reject) => {
      let path = undefined;
      let data = undefined;
      let requireOwner = false;
      if (profile === 'pro-installer' || profile === 'root') {
        path = '/api/v1/localjwt';
        data = {
          user: profile,
          password: password
        };
      } else {
        requireOwner = true;
        path = '/api/v1/jwt';
        data = {
          applicationkey: this.storage.get('appKey'),
          // env: this.storage.get('env') || 'Prod', // NOTE this should be assumed by broker now
          email: profile,
          pwd: password,
          dev: false
        };
      }

      this.http.post(this.url.getBrokerURL(path), data, {
        headers: this.getHeaders(this.getAuthToken())
      }).subscribe(
        res => {
          let data = res.json();
          console.log('local.ts: auth response is', data);

          if (data.token) {
            this.storage.set('authToken', data.token);
            if (requireOwner) {
              // in the consumer auth case we need to go a step further and confirm
              // the provided credential belongs to the primary account holder
              let token = this.storage.get('authToken');
              // console.log('local: stored auth token is', token);
              this.http.get(this.url.getBrokerURL('/api/v1/jwt/user'), {
                headers: this.getHeaders(token)
              }).subscribe(res => {
                let user = res.json();

                if (!!user) {
                  this.storage.set('currentUser', user);
                  if (!user.isOwner) {
                    this.unauthenticate();
                    reject({ message: 'Access to this system is granted only to the primary account owner.  Please login with the primary account owner credentials.' });
                  } else {
                    resolve();
                  }
                }
              }, err => {
                console.error('local.ts: unable to confirm account owner due to service error', err);
                reject(err);
              });
            } else {
              resolve();
            }
          } else {
            if (data.C4ErrorResponse) {
              console.error('local: authenticate: error response returned', data);
              reject(data);
            } else {
              console.error('local: unrecongized response in authenticate', data);
              reject(data);
            }
          }
        },
        error => {
          reject(error);
        });
    });
  }

  unauthenticate(): Promise<any> {
    console.log('local.ts: unauthenticate()');
    return new Promise((resolve, reject) => {
      this.storage.remove('accessToken');
      this.storage.remove('authToken');
      this.storage.remove('profile');
      this.storage.remove('currentUser');
      this.storage.remove('username');
      resolve();
    });
  }

  validateAuthentication(): Promise<boolean> {
    console.log('local.ts: validateAuthentication()');
    return new Promise((resolve, reject) => {
      this.http.get(this.url.getBrokerURL('/api/v1/logger/level'), {
        headers: this.getHeaders(this.getAuthToken())
      }).subscribe(
        response => resolve(true),
        error => {
          this.unauthenticate().then(() => {
            resolve(false);
          });
        });
    });
  }

  getAuthToken(): string {
    return this.storage.get('authToken');
  }

  isAuthenticated(): boolean {
    console.warn('local.ts: isAuthenticated not supported with Local auth');
    return true;
  }

  isAuthorized(): boolean {
    let authToken: string = this.storage.get('authToken');
    return (authToken !== null && authToken.length > 0);
  }

  getCurrentAccount(accessToken: string): Promise<string> {
    console.warn('local.ts: getCurrentAccount not supported with Local auth');
    return new Promise((resolve, reject) => {
      reject({ message: 'unsupported: getCurrentAccoutn unsupported with Local auth' })
    });
  }

  getHeaders(token?: string): Headers {
    let headers = new Headers();
    if (token) {
      headers.append('Authorization', 'Bearer ' + token);
    }
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json; charset=UTF-8');
    return headers;
  }

  checkLicense(profile: string): Promise<boolean> {
    console.log('local: checking license for profile', profile);
    if (profile === 'primary') {
      return new Promise<boolean>((resolve, reject) => {
        this.http.get(this.url.getBrokerURL('/api/v1/jwt/account?licenses=true'), {
          headers: this.getHeaders(this.getAuthToken())
        }).subscribe(res => {
          let data = res.json();
          console.log('local: license response', data);
          resolve(this._has4SightLicense(data));
        }, err => {
          console.error('local: error checking 4sight license', err);
          reject(err);
        });
      });
    } else {
      // NOTE license check not required for root or pro-installer
      return Promise.resolve(true);
    }
  }

  private _has4SightLicense(account: any): boolean {
    let hasLicense = false;

    if (!!account && !!account.licenses && account.licenses.totalCount > 0) {
      let licenses = account.licenses.license || [];
      if (!Array.isArray(licenses)) {
        licenses = [licenses];
      }

      licenses.forEach(lic => {
        // NOTE expired 4sight licenses are not returned, so no need to check the timestamp
        if (lic.name === '4Sight Services') {
          hasLicense = true;
        }
      });
    }

    return hasLicense;
  }
}




// WEBPACK FOOTER //
// ./~/@c4/auth/src/app/strategies/local.ts